import { Link } from "react-router-dom";

type Props = {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
};

export default function EmptyState({ title, description, actionLabel, onAction, actionTo }: Props) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-background-100 text-foreground-400">
        <i className="ri-inbox-archive-line text-2xl" />
      </div>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      <p className="max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          {actionLabel}
        </Link>
      )}
      {actionLabel && !actionTo && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}